import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Text,
 
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { FaEye, FaPlusCircle } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { fetchAsyncUpdateModulePaymentTerms } from "redux/salesInvoiceModuleSlice";
import orgJson from "components/jsonData/orgnization.json";
import {  Form, InputGroup } from "react-bootstrap";
import SalesInvoicePdf from "components/allForm/SalesInvoiceForm/ExportSalesOrder/salesInvoicePdf";


export const defaultPayTerms = [
  { name: "Due on Receipt", days: 0 },
  { name: "3 Days", days: 3 },
    { name: "5 Days", days: 5 },
    { name: "7 Days", days: 7 },
  ]

  export const templateOptions = [
    { name: "Default Template", id:"DefaultTemplate" },
    { name: "Template 1", id:"Template1" },
    { name: "Template 2", id:"Template2" },
    { name: "Template 3", id:"Template3" }
]


const PaymentTerms = ({ isOpen, onClose, isEdit, editData }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const [terms, setTerms] = useState([]);
  const [templateId,setTemplateId] = useState("")
  const [invoiceView,setInvoiceView] = useState(false)
  
  useEffect(() => {
    if (editData && editData?.pyTrms?.length) {
      setTerms(editData?.pyTrms)
    }
    else{
      setTerms(defaultPayTerms)
    }
    if (editData?.tmpId) {
      setTemplateId(editData?.tmpId)
    }
  }, [editData, isEdit]);

  const handleTermChange = (index, field, value) => {
    const updatedTerms = [...terms];
    updatedTerms[index] = { ...updatedTerms[index], [field]: value };    setTerms(updatedTerms);
  };

  const handleAddTerm = () => {
    setTerms([...terms, { name: "", days: "" }]);
  };

  const handleDeleteTerm = (index) => {
    const updatedTerms = terms.filter((_, i) => i !== index);
    setTerms(updatedTerms);
    
  };

  const UpdateModuleTerms = (e) => {
      dispatch(fetchAsyncUpdateModulePaymentTerms({id:editData?._id,data:{terms,tmpId:templateId}}))
      .then((res) => {
        if (res?.payload) {
          addToast("Payment terms saved successfully!", { appearance: "success" });
          onClose()

        } else {
          addToast(res?.error?.message, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(orgJson.error.generic, { appearance: "error" });
      });
  };
  
  const handleSave = (e) => {
    e.preventDefault()
    const hasEmptyFields = terms.some(term => !term.name || term.days === "");
    const daysSet = new Set();
    let hasDuplicateDays = false;
    terms.forEach(term => {
      if (daysSet.has(term.days)) {
        hasDuplicateDays = true;
      }
      daysSet.add(term.days);
    });
    if (hasEmptyFields) {
      addToast("Enter a valid Term name and days.", { appearance: 'error' });
      return;
    }
    if (hasDuplicateDays) {
      addToast("Number of Days must be unique.", { appearance: 'error' });
      return;
    }
    UpdateModuleTerms();
   
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxH="fit-content" className=" payment-terms-modal">
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              <h6 className="module-heading">
                Configure {editData?.name} Module
              </h6>
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalBody className="mt-5" minW="320px" maxW="100%">
            <h5 className="module-heading mb-2 fw-600">
              Configure Payment Terms :{" "}
            </h5>

            <Table variant="simple" size="md">
              <Thead>
                <Tr>
                  <Th>Term Name</Th>
                  <Th className="text-end">Number of Days</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {terms.map((term, index) => (
                  <Tr key={index}>
                    <Td>
                      <Input
                        value={term.name}
                        placeholder="Term Name"
                        disabled={index === 0}
                        onChange={(e) =>
                          handleTermChange(index, "name", e.target.value)
                        }
                      />
                    </Td>
                    <Td>
                      <Input
                        className="text-end"
                        value={term.days}
                        placeholder="Days"
                        type="number"
                        disabled={index === 0}
                        min={0}
                        onChange={(e) =>
                          handleTermChange(
                            index,
                            "days",
                            Number(e.target.value)
                          )
                        }
                      />
                    </Td>

                    <Td>
                      {index === 0 ? (
                        <AiFillDelete
                          style={{
                            cursor: "not-allowed",
                            color: "#c3473e",
                            marginLeft: "25px",
                            marginBottom: "10px",
                          }}
                          className="disabled-btn"
                          size={16}
                        />
                      ) : (
                        <AiFillDelete
                          style={{
                            cursor: "pointer",
                            color: "#c3473e",
                            marginLeft: "25px",
                            marginBottom: "10px",
                          }}
                          size={16}
                          onClick={(e) => {
                            handleDeleteTerm(index);
                          }}
                        />
                      )}
                    </Td>
                  </Tr>
                ))}
                {!!terms?.length && <>
                  <Tr>
                    <Td>
                      <Input
                        value="Custom"
                        placeholder="Term Name"
                        disabled
                      />
                    </Td>
                    <Td>
                      <Input
                        className="text-end"
                        value='-'
                        placeholder="Days"
                        disabled
                      />
                    </Td>

                    <Td>
                        <AiFillDelete
                          style={{
                            cursor: "not-allowed",
                            color: "#c3473e",
                            marginLeft: "25px",
                            marginBottom: "10px",
                          }}
                          className="disabled-btn"
                          size={16}
                        />
                    </Td>
                  </Tr>
                </>}
              </Tbody>
            </Table>
            <Box display="flex" alignItems="center" className="mt-3">
              <Button
                className="add-project mt-2 mx-0"
                onClick={() => handleAddTerm()}
                minWidth={0}
              >
                <FaPlusCircle className="add-project-icon" size={16} />
                <Text className="mx-2 add-new-text">Add New Term</Text>
              </Button>
            </Box>

            <h5 className="module-heading mt-2 mb-2 fw-600">
              Invoice Formate :{" "}
            </h5>

            <InputGroup className="input-group">
              <Form.Select
                className="input1"
                style={{ boxShadow: "none" }}
                value={templateId}
                onChange={(e) => setTemplateId(e?.target?.value)}
              >
                {templateOptions?.map((item) => {
                  return <option value={item?.id}>{item?.name}</option>;
                })}
              </Form.Select>
              <InputGroup.Text>
                <FaEye
                  title="View Template"
                  size={18}
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    marginLeft: "7px",
                  }}
                  onClick={(e) => setInvoiceView(true)}
                />
              </InputGroup.Text>
            </InputGroup>
          </ModalBody>

          <ModalFooter className="setting-module-footer">
            <Button
              onClick={(e) => handleSave(e)}
              className="btn save-btn"
              mr={3}
            >
              Save
            </Button>
            <Button onClick={onClose} className="btn">
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {invoiceView && (
        <SalesInvoicePdf
          isOpen={invoiceView}
          onClose={() => {
            setInvoiceView(!invoiceView);
          }}
          isProforma={false}
          expenseData={{ inNo: { prfx: "INV-", n: "00" } }}
          itemList={[
            {
              slItm: {
                name: "Test Service in INR for client 2",
                dc: "The rate at which you're going to sell this item.",
                sCd: "111111",
              },
              qty: 2,
              prc: 1000,
              tax: {},
              amt: 2000,
            },
          ]}
          clientGst=""
          gstAmount={{ i: 20 }}
          adjustmentAmount={100}
          shippingCharge={100}
          totalPaymentAmount={2220}
          gstType="IGST"
          total={{ amt: 2000 }}
          clientId=""
          currency="INR"
          terms={{}}
          subject="Change Note#1"
          notes="Thanks for the business."
          templateId={templateId}
          isPreview={true}
        />
      )}
    </>
  );
};

export default PaymentTerms;
